import { updateManagerPageStep } from "./managerPageWizardService";
import apiClient from "./ApiService";

/**
 * Guarda los datos del paso COST
 * - Envía al backend
 * - Actualiza ManagerPage
 */
export const saveCostStep = async ({ idTransaction, data }) => {
  const dto = {
    idAdmin: idTransaction,
    membershipCurrency: data.moneda,
    membershipPaymentMethod: "DAT",
    crcAccount: data.cuentaSeleccionadaCRC || null,
    usdAccount: data.cuentaSeleccionadaUSD || null,
    totalDepositAmountCrc: data.montoTotalDepositoCRC || null,
    totalDepositAmountUsd: data.montoTotalDepositoUSD || null,
    apnfd: Boolean(data.industriaSeleccionada && data.industriaSeleccionada !== "0"),
    industryId:
      data.industriaSeleccionada && data.industriaSeleccionada !== "0"
        ? Number(data.industriaSeleccionada)
        : 0,
    exclusiveApnfdAccount: !(data.industriaSeleccionada && data.industriaSeleccionada !== "0") ? null :
      data.cuentaSeleccionadaCRC && data.cuentaSeleccionadaUSD
        ? `${data.cuentaSeleccionadaCRC}-${data.cuentaSeleccionadaUSD}`
        : data.cuentaSeleccionadaCRC || data.cuentaSeleccionadaUSD || null,
  };

  if (data.recibeTransferenciasInternacionales === "si") {
    dto.incomingAmount = data.tiMontoEntranteUsd || null;
    dto.outgoingAmount = data.tiMontoSalienteUsd || null;
    dto.detail = data.tiMotivoUsoRecurrente || null;
  } else {
    dto.incomingAmount = null;
    dto.outgoingAmount = null;
    dto.detail = null;
  }

  try {
    console.log("COST SAVE PAYLOAD:", dto);
   const result = await apiClient.post(
      "/adelselfservice/selfservice/costs",
      dto
    );

    await updateManagerPageStep(idTransaction, "costs");
    return result;
  } catch (e) {
    throw new Error("Error guardando costos");
  }
};

/**
 * Obtiene los costos existentes
 */
export async function getCostStep(idAdmin) {
  try {
    const result = await apiClient.get(
      `/adelselfservice/selfservice/costs/admin/${idAdmin}`
    );

    console.log("COST RESULT:", result);

    return result;
  } catch (e) {
    throw new Error("Error obteniendo costos");
  }
}